import { AppController } from "../AppController";
var AgbPage = /** @class */ (function () {
    function AgbPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(AgbPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgbPage.prototype, "organization", {
        get: function () {
            return this.appController.organization;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgbPage.prototype, "agbText", {
        get: function () {
            return this.appController.agbText;
        },
        enumerable: true,
        configurable: true
    });
    return AgbPage;
}());
export { AgbPage };
